{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Seletor de cores",
  "colorSwatch": "amostra de cores",
  "transparent": "transparente",
  "twoDimensionalSlider": "Controle deslizante 2D"
}
